import EventService from '../../services/Events';
import { HTTP_STATUS_CODE } from '../../helpers/constants';

export const LOADING_EVENTS = 'LOADING_EVENTS';
const loadingEvents = () => ({
  type: LOADING_EVENTS,
});

export const LOADING_ACCOUNTS = 'LOADING_ACCOUNTS';
const loadingAccounts = () => ({
  type: LOADING_ACCOUNTS,
});

export const LOADING_ACCOUNT = 'LOADING_ACCOUNT';
export const loadingAccount = () => ({
  type: LOADING_ACCOUNT,
});

export const RECEIVE_EVENTS = 'RECEIVE_EVENTS';
const receiveEvents = events => ({
  type: RECEIVE_EVENTS,
  events,
});

export const RECEIVE_ACCOUNTS = 'RECEIVE_ACCOUNTS';
const receiveAccounts = accounts => ({
  type: RECEIVE_ACCOUNTS,
  accounts,
});

export const RECEIVE_ACCOUNT = 'RECEIVE_ACCOUNT';
const receiveAccount = account => ({
  type: RECEIVE_ACCOUNT,
  account,
});

export const TOGGLE_REPETITION = 'TOGGLE_REPETITION';
export const toggleRepetition = (exibithionId, repetitionId) => ({
  type: TOGGLE_REPETITION,
  exibithionId,
  repetitionId,
});

export const TOGGLE_ALL = 'TOGGLE_ALL';
export const toggleAll = exibithionId => ({
  type: TOGGLE_ALL,
  exibithionId,
});

export const TOGGLE_SECTOR = 'TOGGLE_SECTOR';
export const toggleSector = (sectorId, repetitions) => ({
  type: TOGGLE_SECTOR,
  sectorId,
  repetitions,
});

export const TOGGLE_ALL_SECTORS = 'TOGGLE_ALL_SECTORS';
export const toggleAllSectors = repetitions => ({
  type: TOGGLE_ALL_SECTORS,
  repetitions,
});

export const TOGGLE_BENEFIT = 'TOGGLE_BENEFIT';
export const toggleBenefit = (sectorId, benefitId) => ({
  type: TOGGLE_BENEFIT,
  sectorId,
  benefitId,
});

export const TOGGLE_ALL_BENEFITS_IN_ACCORDION = 'TOGGLE_ALL_BENEFITS_IN_ACCORDION';
export const toggleAllBenefitsInAccordion = sectorId => ({
  type: TOGGLE_ALL_BENEFITS_IN_ACCORDION,
  sectorId,
});

export const TOGGLE_ALL_BENEFITS = 'TOGGLE_ALL_BENEFITS';
export const toggleAllBenefits = repetitions => ({
  type: TOGGLE_ALL_BENEFITS,
  repetitions,
});

export const CLEAR_SECTORS = 'CLEAR_SECTORS';
export const clearSectors = () => ({
  type: CLEAR_SECTORS,
});

export const FINISH_RECEIVE_EVENTS = 'FINISH_RECEIVE_EVENTS';
export const finishReceiveEvents = () => ({
  type: FINISH_RECEIVE_EVENTS,
});

export const SYNC_STORAGE_EVENTS = 'SYNC_STORAGE_EVENTS';
export const syncStorageEvents = events => ({
  type: SYNC_STORAGE_EVENTS,
  events,
});

export const VALIDATE_MENU_EVENTS = 'VALIDATE_MENU_EVENTS';
export const validateMenuEvents = (menus, accountId, saleType, idMenu) => ({
  type: VALIDATE_MENU_EVENTS,
  menus,
  accountId,
  saleType,
  idMenu,
});

export const CLEAR_EVENTS = 'CLEAR_EVENTS';
export const clearEvents = () => ({
  type: CLEAR_EVENTS,
});

export const getEvents = idAccount => {
  return async dispatch => {
    dispatch(loadingEvents());
    try {
      const response = await new EventService().getEvents(idAccount);
      dispatch(receiveEvents(response.data));
    } catch (err) {
      console.error('error', err);
    }
  };
};

export const getAccounts = () => {
  return async dispatch => {
    dispatch(loadingAccounts());
    try {
      const response = await new EventService().getAccounts();
      if (response.status !== HTTP_STATUS_CODE.OK) {
        throw new Error(response.data.error.message);
      }
      dispatch(receiveAccounts(response.data));
    } catch (err) {
      console.error('error', err);
    }
  };
};

export const getAccount = cnpj => {
  return async dispatch => {
    dispatch(loadingAccount());
    try {
      const { data } = await new EventService().getAccount(cnpj);
      dispatch(receiveAccount(data.length ? data[0] : data));
    } catch (err) {
      console.error('error', err);
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/events/actions.js